// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"a10a3f92e9--wrapper--je9uq","icon":"a10a3f92e9--icon--q_vp8","title":"a10a3f92e9--title--zyDrK","message":"a10a3f92e9--message--LGHd_"};